<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-select ttRememberId="bankreconciliations.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-date ttRememberId="bankreconciliations.balance_date" ttLabel="balance_date" [(ttModel)]="setting.balance_date" (ttModelChange)="onChanged($event, 'balance_date')"></tt-date>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
